const ITEMS = [
  "Tax Preparation",
  "Wealth Preservation",
  "401(k) Rollovers",
  "Estate Planning",
  "Life Insurance",
  "Debt Relief",
  "GFI Global Financial Impact",
  "License #21413773",
  "Build Your Legacy",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="px-8 font-display text-sm uppercase tracking-[0.3em] text-white/45">
          {item}
        </span>
        <span className="text-gold" aria-hidden="true">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    className="relative overflow-hidden border-y border-gold/15 bg-[#0F091A] py-6"
    data-testid="editorial-marquee"
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
